// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    tasks: {
      label: 'Tareas',
      help: 'Una fila por tarea apuntada: qué queda pendiente, sobre qué y cuánto se hace de lo que se anota',
    },
    dates: {
      created: 'Fecha en que se apuntó',
      done: 'Fecha en que se hizo',
      due: 'Fecha límite',
    },
    metrics: {
      tasks: 'Tareas',
      open: 'Pendientes',
      done: 'Hechas',
      skipped: 'No se pudo',
      cancelled: 'Anuladas',
      daysToDo: 'Días hasta hacerse',
      doneRate: 'Porcentaje hechas',
    },
    dimensions: {
      type: 'Tipo',
      status: 'Estado',
      priority: 'Prioridad',
      subjectType: 'Tipo de cosa',
      subject: 'Sobre qué',
      assignee: 'Responsable',
    },
  },

  ca: {
    tasks: {
      label: 'Tasques',
      help: 'Una fila per tasca apuntada: què queda pendent, sobre què i quant se’n fa del que s’anota',
    },
    dates: {
      created: 'Data en què es va apuntar',
      done: 'Data en què es va fer',
      due: 'Data límit',
    },
    metrics: {
      tasks: 'Tasques',
      open: 'Pendents',
      done: 'Fetes',
      skipped: 'No es va poder',
      cancelled: 'Anul·lades',
      daysToDo: 'Dies fins a fer-se',
      doneRate: 'Percentatge fetes',
    },
    dimensions: {
      type: 'Tipus',
      status: 'Estat',
      priority: 'Prioritat',
      subjectType: 'Tipus de cosa',
      subject: 'Sobre què',
      assignee: 'Responsable',
    },
  },

  en: {
    tasks: {
      label: 'Tasks',
      help: 'One row per task noted down: what is pending, what about, and how much of it gets done',
    },
    dates: {
      created: 'Date noted',
      done: 'Date done',
      due: 'Due date',
    },
    metrics: {
      tasks: 'Tasks',
      open: 'Pending',
      done: 'Done',
      skipped: 'Could not do',
      cancelled: 'Called off',
      daysToDo: 'Days to do',
      doneRate: 'Done rate',
    },
    dimensions: {
      type: 'Kind',
      status: 'State',
      priority: 'Priority',
      subjectType: 'Kind of thing',
      subject: 'About',
      assignee: 'Owner',
    },
  },

  fr: {
    tasks: {
      label: 'Tâches',
      help: 'Une ligne par tâche notée : ce qui reste à faire, sur quoi, et combien se fait de ce qu’on note',
    },
    dates: {
      created: 'Date de saisie',
      done: 'Date de réalisation',
      due: 'Date d’échéance',
    },
    metrics: {
      tasks: 'Tâches',
      open: 'En attente',
      done: 'Faites',
      skipped: 'N’a pas pu',
      cancelled: 'Annulées',
      daysToDo: 'Jours pour faire',
      doneRate: 'Pourcentage faites',
    },
    dimensions: {
      type: 'Type',
      status: 'État',
      priority: 'Priorité',
      subjectType: 'Type de chose',
      subject: 'Concerne',
      assignee: 'Responsable',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of a thousand.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
